import { render, staticRenderFns } from "./department.vue?vue&type=template&id=7b0784cb"
import script from "./department.vue?vue&type=script&lang=ts"
export * from "./department.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports